import { Typography, makeStyles } from '@material-ui/core';
import { HostContext } from 'App';
import { useContext } from 'react';
import { Layout as BaseLayout, AppBar as BaseAppBar } from 'react-admin';
import UserMenu from "./UserMenu";

const useStyles = makeStyles({
    spacer: {
        flex: 1,
    },
    title: {
        flex: 1,
        
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
    }
})

const AppBar = props => {
    const {activeOrganization} = useContext(HostContext);
    const classes = useStyles();

    return (
        <BaseAppBar {...props} userMenu={<UserMenu />}>
            <Typography
                variant="h6"
                color="inherit"
                id="react-admin-title"
                className={classes.title}
            />
            <Typography
                variant="h6"
                color="inherit"
            >
                {activeOrganization?.name} 
            </Typography>

            <span className={classes.spacer} />
        </BaseAppBar>
    )
};

const Layout = props => <BaseLayout
    {...props}
    appBar={AppBar}
/>;

export default Layout;
